/* ==========================================================================
   DN: Subscription Buy-Box (Custom Element)
   - Radio "Einmalkauf" vs "Abo & 15 % sparen" (Abo default, falls Plan vorhanden)
   - Injiziert selling_plan in ALLE cart-add-Forms (Pattern aus dn-quantity-tiers.js)
   - Dynamischer Preis: ±X % (aus data-discount), reagiert auf Quantity-Tier-Wechsel
   - Money-Formatierung via Reverse-Engineering eines Liquid-money-Samples
   - Anchor-CTAs (href="#dn-buybox") scrollen hoch + wählen Abo vor
   ========================================================================== */
(function () {
  'use strict';

  /* Aus einem Liquid-gerenderten Money-Sample (123456 Cent) Prefix/Suffix/Dezimal ableiten. */
  function parseMoneyFormat(sample) {
    var fallback = { prefix: '', suffix: ' €', decimals: 2, decSep: ',', thouSep: '.' };
    if (!sample) return fallback;

    // Erste Ziffer / letzte Ziffer finden → alles davor = Prefix, alles danach = Suffix.
    var firstDigit = sample.search(/\d/);
    var lastDigit = -1;
    for (var i = sample.length - 1; i >= 0; i--) {
      if (/\d/.test(sample[i])) { lastDigit = i; break; }
    }
    if (firstDigit === -1) return fallback;

    var prefix = sample.slice(0, firstDigit);
    var suffix = sample.slice(lastDigit + 1);
    var numberPart = sample.slice(firstDigit, lastDigit + 1);

    // Sample = 1234,56 → Separatoren erkennen.
    var decimals = 2;
    var decSep = ',';
    var thouSep = '.';

    // Letztes nicht-Ziffern-Zeichen im numberPart = Dezimaltrenner (falls 1–2 Nachkommastellen folgen).
    var m = numberPart.match(/^(\d[\d.,\s']*?)([.,])(\d{1,2})$/);
    if (m) {
      decSep = m[2];
      decimals = m[3].length;
      // Tausendertrenner = der andere gängige Separator im Ganzzahlteil.
      var intPart = m[1];
      if (decSep === ',') {
        thouSep = /\./.test(intPart) ? '.' : (/\s/.test(intPart) ? ' ' : (/'/.test(intPart) ? "'" : '.'));
      } else {
        thouSep = /,/.test(intPart) ? ',' : (/\s/.test(intPart) ? ' ' : (/'/.test(intPart) ? "'" : ','));
      }
    } else {
      // Keine Nachkommastellen im Sample (money_with_currency ohne Cents o.Ä.)
      decimals = 0;
      thouSep = /\./.test(numberPart) ? '.' : (/,/.test(numberPart) ? ',' : (/\s/.test(numberPart) ? ' ' : '.'));
    }

    return { prefix: prefix, suffix: suffix, decimals: decimals, decSep: decSep, thouSep: thouSep };
  }

  function formatMoney(cents, fmt) {
    var value = (cents / 100);
    var fixed = value.toFixed(fmt.decimals);
    var parts = fixed.split('.');
    var intStr = parts[0];
    var decStr = parts[1] || '';

    // Tausendertrennung
    intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thouSep || '');

    var out = intStr;
    if (fmt.decimals > 0) out += fmt.decSep + decStr;
    return fmt.prefix + out + fmt.suffix;
  }

  class DnSubscriptionBuybox extends HTMLElement {
    connectedCallback() {
      this.discount = parseFloat(this.dataset.discount || '15');

      /* Mengenstaffel des Produkts, z. B. [{"q":1,"d":0},{"q":3,"d":10},{"q":6,"d":20}].
         Wird gebraucht, weil die Automatikrabatte appliesOnSubscription=false tragen:
         beim Einmalkauf gilt die Staffel, im Abo nur der Plan-Rabatt. Ohne das zeigt
         die Box im Abo einen Preis an, den der Warenkorb nicht bestaetigt. */
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        this.tiers = [];
      }
      this.unitPrice = parseInt(this.dataset.unitPrice || this.dataset.onetimePrice || '0', 10);
      this.hasPlan = this.dataset.hasPlan === 'true';
      this.fmt = parseMoneyFormat(this.dataset.moneySample);

      this.radios = this.querySelectorAll('input[name="dn_sub_mode"]');
      this.options = this.querySelectorAll('.dn-sub__option');
      this.planInput = this.querySelector('input[name="selling_plan"][data-dn-sub]');
      this.intervalRadios = this.querySelectorAll('input[name="dn_sub_interval"]');

      // Scope: product-info / product-form / Section.
      this.scope =
        this.closest('product-info, product-form, .shopify-section, main') || document;

      this.radios.forEach((r) =>
        r.addEventListener('change', () => this.onModeChange())
      );

      // Intervall gewählt → Abo aktivieren + Plan auf das gewählte Intervall setzen.
      this.intervalRadios.forEach((r) =>
        r.addEventListener('change', () => this.onIntervalChange())
      );

      /* Mengenwechsel → Preise neu rechnen.
         Bewusst als Delegation auf Dokumentebene: dn-quantity-tiers.js legt seine
         versteckten quantity-Inputs erst beim ersten Klick in den Formularen an.
         Wer beim Verbinden fest an die vorhandenen Elemente bindet, verpasst
         genau diese - die Box blieb dann auf der Menge 1 stehen.
         setTimeout(0) statt requestAnimationFrame, damit der Tier-Handler den
         Wert in jedem Fall vorher geschrieben hat. */
      var neuRechnen = () => window.setTimeout(() => this.recalcPrices(), 0);
      document.addEventListener('click', (e) => {
        if (e.target && e.target.closest && e.target.closest('.dn-qt__tile')) neuRechnen();
      });
      document.addEventListener('change', (e) => {
        if (e.target && e.target.name === 'quantity') neuRechnen();
      });

      // Initialzustand anwenden.
      this.markActive();
      this.markActiveInterval();
      this.applyPlanToForms();
      this.recalcPrices();

      // Anchor-CTAs (z.B. "Abo wählen ›" mit href="#dn-buybox") → Abo vorselektieren.
      this.bindAnchorCtas();
    }

    currentQty() {
      var qInput =
        this.scope.querySelector('input[name="quantity"][data-dn-qt]') ||
        this.scope.querySelector('input[name="quantity"]');
      var q = qInput ? parseInt(qInput.value, 10) : 1;
      return q && q > 0 ? q : 1;
    }

    /* Aktueller Modus: 'subscription' oder 'one-time'. */
    currentMode() {
      var checked = this.querySelector('input[name="dn_sub_mode"]:checked');
      return checked ? checked.value : (this.hasPlan ? 'subscription' : 'one-time');
    }

    onModeChange() {
      this.markActive();
      this.applyPlanToForms();
    }

    markActive() {
      var mode = this.currentMode();
      this.options.forEach((opt) => {
        opt.classList.toggle('is-active', opt.dataset.mode === mode);
      });
    }

    /* Intervall-Wahl impliziert Abo → Abo aktivieren, Plan neu setzen. */
    onIntervalChange() {
      var subRadio = this.querySelector('input[name="dn_sub_mode"][value="subscription"]');
      if (subRadio && !subRadio.checked) subRadio.checked = true;
      this.markActiveInterval();
      this.markActive();
      this.applyPlanToForms();
    }

    markActiveInterval() {
      this.intervalRadios.forEach((r) => {
        var lab = r.closest('.dn-sub__interval');
        if (lab) lab.classList.toggle('is-active', r.checked);
      });
    }

    /* Gewähltes Intervall = selling_plan; Fallback auf Quell-Plan. */
    currentPlanId() {
      var iv = this.querySelector('input[name="dn_sub_interval"]:checked');
      if (iv && iv.value) return iv.value;
      return this.planInput ? this.planInput.value : '';
    }

    /* selling_plan in ALLE cart-add-Forms injizieren (Pattern aus dn-quantity-tiers.js). */
    applyPlanToForms() {
      if (!this.hasPlan || !this.planInput) return;
      var planId = this.currentPlanId();
      this.planInput.value = planId;
      var subscribe = this.currentMode() === 'subscription';

      this.scope.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        var hidden = form.querySelector('input[name="selling_plan"][data-dn-sub-injected]');
        if (subscribe) {
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'selling_plan';
            hidden.setAttribute('data-dn-sub-injected', 'true');
            form.appendChild(hidden);
          }
          hidden.value = planId;
          hidden.disabled = false;
        } else if (hidden) {
          // Einmalkauf → Plan entfernen (disabled, damit nichts mitgesendet wird).
          hidden.value = '';
          hidden.disabled = true;
        }
      });

      // Quell-Input selbst beim Einmalkauf deaktivieren, sonst sendet sein form="" Attribut mit.
      this.planInput.disabled = !subscribe;
    }

    /* Hoechster Staffelrabatt, der bei dieser Menge greift. */
    tierDiscount(qty) {
      var best = 0;
      for (var i = 0; i < this.tiers.length; i++) {
        var t = this.tiers[i];
        if (qty >= t.q && t.d > best) best = t.d;
      }
      return best;
    }

    recalcPrices() {
      var qty = this.currentQty();
      /* Rundung exakt wie Shopify, im Warenkorb gegen /cart.js verifiziert:
         - Automatikrabatt (Mengenstaffel): Rabatt JE STUECK, abgerundet
           24,99 × 15 % = 3,7485 -> 3,74 -> ×6 = 22,44 -> Zeile 127,50
         - Selling Plan (Abo): PREIS je Stueck, kaufmaennisch gerundet
           24,99 × 0,85 = 21,2415 -> 21,24 -> ×6 = 127,44
         Auf den Gesamtbetrag gerechnet lag die Anzeige 3 bis 5 Cent unter dem,
         was tatsaechlich berechnet wird. */
      var rabattJeStueck = Math.floor(this.unitPrice * this.tierDiscount(qty) / 100);
      var onetimeTotal = (this.unitPrice - rabattJeStueck) * qty;
      var subTotal = Math.round(this.unitPrice * (100 - this.discount) / 100) * qty;
      var savings = onetimeTotal - subTotal;

      var elOne = this.querySelector('[data-dn-sub-price="one-time"]');
      var elSub = this.querySelector('[data-dn-sub-price="subscription"]');
      var elOld = this.querySelector('[data-dn-sub-price-old]');
      var elSav = this.querySelector('[data-dn-sub-savings]');

      if (elOne) elOne.textContent = formatMoney(onetimeTotal, this.fmt);
      if (elSub) elSub.textContent = formatMoney(subTotal, this.fmt);
      /* Streichpreis nur, wenn er sich vom Abopreis unterscheidet. Bei gleicher
         Menge koennen beide zusammenfallen (Staffel 15 % gegen Plan 15 %); ein
         durchgestrichener Preis in identischer Hoehe wirkt wie ein Fehler. */
      if (elOld) {
        elOld.textContent = formatMoney(onetimeTotal, this.fmt);
        elOld.hidden = savings <= 0;
      }
      /* Bei gleicher Menge kann der Abo-Vorteil auf 0 fallen (z. B. Staffel 20 %
         gegen Plan 20 %). Dann keine Ersparnis behaupten. */
      if (elSav) {
        elSav.textContent = savings > 0 ? 'Spare ' + formatMoney(savings, this.fmt) : '';
        elSav.hidden = savings <= 0;
      }
    }

    bindAnchorCtas() {
      var self = this;
      document.querySelectorAll('a[href="#dn-buybox"]').forEach((a) => {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          // Abo vorselektieren (falls verfügbar), sonst nur scrollen.
          if (self.hasPlan) {
            var subRadio = self.querySelector(
              'input[name="dn_sub_mode"][value="subscription"]'
            );
            if (subRadio) {
              subRadio.checked = true;
              subRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          self.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    }
  }

  if (!customElements.get('dn-subscription-buybox')) {
    customElements.define('dn-subscription-buybox', DnSubscriptionBuybox);
  }
})();
